// 桌面 / iPad 表格：首列吸左，表头吸顶，整行可点（规格照订单 OrdersTable）。
// 由外层 .dbody 负责滚动，所以这里不再套滚动容器。建议主会话提取到 src/components。
import type { ReactNode } from 'react';
import s from './Table.module.css';

export type Col<T> = {
  key: string;
  title: ReactNode;
  w?: number;
  align?: 'r';
  fix?: boolean;
  fixLeft?: number;
  fixRight?: boolean;
  render: (row: T) => ReactNode;
};

/** 两行单元格：主值 + 灰色小字 */
export function Two({ top, sub, end }: { top: ReactNode; sub?: ReactNode; end?: boolean }) {
  return <div className={`${s.two} ${end ? s.end : ''}`}><span>{top}</span>{sub != null && sub !== '' && <small>{sub}</small>}</div>;
}

export function DataTable<T extends { id: string }>({ cols, rows, onRow, selectedId, minWidth }: { cols: Col<T>[]; rows: T[]; onRow?: (row: T) => void; selectedId?: string; minWidth?: number }) {
  return (
    <table className={s.tbl} style={minWidth ? { minWidth } : undefined}>
      <colgroup>{cols.map((c) => <col key={c.key} style={{ width: c.w }} />)}</colgroup>
      <thead>
        <tr>{cols.map((c) => <th key={c.key} style={c.fixLeft != null ? { left: c.fixLeft } : undefined} className={[(c.fix || c.fixLeft != null) && s.fix, c.fixRight && s.fixR, c.align === 'r' && s.r].filter(Boolean).join(' ')}>{c.title}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id} className={[onRow && s.click, row.id === selectedId && s.sel].filter(Boolean).join(' ')} onClick={onRow ? () => onRow(row) : undefined}>
            {cols.map((c) => <td key={c.key} style={c.fixLeft != null ? { left: c.fixLeft } : undefined} className={[(c.fix || c.fixLeft != null) && s.fix, c.fixRight && s.fixR, c.align === 'r' && s.r].filter(Boolean).join(' ')}>{c.render(row)}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
